import latestPost from "./latestPost.json";
import searchPost from "./searchPost.json";

export default {
  latestPost,
  searchPost,
};
